import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" From: ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" To: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "Audit Logs" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { gutter: 14 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: { span: 12 },
            md: { span: 5},
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_a_date_picker, {
                value: _ctx.from,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.from) = $event)),
                style: {"width":"100%"},
                onChange: _ctx.index
              }, null, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: { span: 12 },
            md: { span: 5},
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_a_date_picker, {
                value: _ctx.to,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.to) = $event)),
                style: {"width":"100%"},
                onChange: _ctx.index
              }, null, 8, ["value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DataTable, {
        loading: _ctx.loading === 'loading',
        data: _ctx.items.data,
        columns: _ctx.fields,
        pagination: _ctx.items,
        onFilter: _ctx.filterRecord,
        "show-search": false,
        "show-create-button": false,
        downloadAuditLogs: true,
        onDownloadAuditLogs: _ctx.handleSubmit
      }, null, 8, ["loading", "data", "columns", "pagination", "onFilter", "onDownloadAuditLogs"])
    ]),
    _: 1
  }))
}